'use client';

import * as styles from '../styles.css';

import AgreeToTerms from '@nrdy-marketing-engine/cart/src/components/details-step/agree-to-terms/agree-to-terms';
import ContinueButton from '@nrdy-marketing-engine/cart/src/components/shared/continue-button';
import AccountFormValues from '@nrdy-marketing-engine/forms/@types/account-form-values';
import LearnerPanel from '@nrdy-marketing-engine/forms/@types/learner-panel';
import { EmailField, PasswordField } from '@nrdy-marketing-engine/inputs';
import clsx from 'clsx';
import { MouseEvent, useCallback } from 'react';
import { logFieldChange } from '../../tracking-utils/freemium-forms-loggers';
import useValidateEmail from './hooks/use-validate-email';

export function CreateFreemiumAccountPanel({
  control,
  formState,
  loading,
  onSubmit,
}: LearnerPanel<AccountFormValues>) {
  const { loading: checkingEmail, validateEmail } = useValidateEmail({ control });

  const handleContinueClick = useCallback(
    async (e: MouseEvent<HTMLButtonElement | HTMLDivElement>) => {
      e.preventDefault();
      if (await validateEmail()) onSubmit();
    },
    [onSubmit, validateEmail]
  );

  const continueButtonIsDisabled = !formState.isValid;

  return (
    <>
      <div>
        <div className={styles.titleContainer}>
          <h1 className={styles.title}>Create account</h1>
        </div>
        <div className={styles.inputWrapper}>
          <EmailField
            control={control}
            error={!!formState.errors.email?.message}
            helperText={formState.errors.email?.message}
            onBlur={logFieldChange}
            placeholder="Email address"
          />
          <div className={clsx(styles.helperText, styles.small)}>
            All learners on your account will use this email and password for access
          </div>
        </div>
        <div className={styles.passwordWrapper}>
          <PasswordField
            control={control}
            error={!!formState.errors.password?.message}
            helperText={formState.errors.password?.message}
            onBlur={logFieldChange}
            placeholder="Password"
          />
        </div>
      </div>
      <div>
        <div className={styles.agreeToTermsWrapper}>
          <AgreeToTerms
            contracts={[]}
            control={control}
            errorMessage={formState.errors.agreeToTerms?.message}
            onClick={logFieldChange}
          />
        </div>
        <ContinueButton
          color="secondary"
          disabled={continueButtonIsDisabled}
          loading={loading || checkingEmail}
          onClick={handleContinueClick}
          onMouseUp={logFieldChange}
          type="submit"
        />
        <div className={clsx(styles.bottomTextAndLink, styles.small)}>
          {'Already have an account?'}{' '}
          <a className={styles.linkHoverUnderline} href="/login">
            Sign in
          </a>
        </div>
      </div>
    </>
  );
}

export default CreateFreemiumAccountPanel;
